import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CategoryDropdown from "@/components/base/CategoryDropdown";
import { mainSiteUrl, categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 20);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-lg font-bold tracking-tight text-foreground-900 whitespace-nowrap cursor-pointer"
            >
              Kakobuy<span className="font-normal text-foreground-600">Finds</span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors duration-200 rounded-lg hover:bg-background-200/60 whitespace-nowrap cursor-pointer"
              >
                Strona Główna
              </Link>
              <Link
                to="/artykul/kakobuy-jak-zaczac"
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors duration-200 rounded-lg hover:bg-background-200/60 whitespace-nowrap cursor-pointer"
              >
                Poradnik Zakupowy
              </Link>
              <CategoryDropdown />
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>Kakobuy Spreadsheet</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>Buy It Now</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl text-foreground-900`}></i>
            </div>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-5 border-t border-background-200 mt-1 pt-4">
            <div className="flex flex-col gap-1 mb-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-900 hover:bg-background-200/60 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-home-4-line text-lg text-foreground-700"></i>
                </div>
                Strona Główna
              </Link>
              <Link
                to="/artykul/kakobuy-jak-zaczac"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-900 hover:bg-background-200/60 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-book-open-line text-lg text-foreground-700"></i>
                </div>
                Poradnik Zakupowy
              </Link>
            </div>

            <div className="px-4 mb-3">
              <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-2">Kategorie</p>
              <div className="grid grid-cols-2 gap-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-xs font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-200/60 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-xs text-foreground-400"></i>
                    </div>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="px-4 pt-3 border-t border-background-200 flex flex-col gap-2">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-1.5 px-5 py-3 bg-foreground-900 text-background-50 rounded-xl text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                <span>Kakobuy Spreadsheet</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-1.5 px-5 py-3 bg-accent-500 text-background-50 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap"
              >
                <span>Buy It Now</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}